import { render, staticRenderFns } from "./po-inspection.vue?vue&type=template&id=37a118fd&"
import script from "./po-inspection.vue?vue&type=script&lang=js&"
export * from "./po-inspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports